import type { UserWorkspaceConfig, ViteUserConfig } from './external.js'

/**
 * Default configuration for {@linkcode vitestProject}.
 *
 * @since 0.0.5
 * @public
 */
export const vitestProjectDefaults = {
  /**
   * @default { 'import.meta.vitest': 'undefined' }
   */
  define: {
    /**
     * @default 'undefined'
     */
    'import.meta.vitest': 'undefined',
  },

  test: {
    /**
     * @default true
     */
    clearMocks: true,

    /**
     * @default true
     */
    globals: true,

    /**
     * @default { enabled: true, tsconfig: './tsconfig.json' }
     */
    typecheck: {
      /**
       * @default true
       */
      enabled: true,

      /**
       * @default './tsconfig.json'
       */
      tsconfig: './tsconfig.json',
    },

    /**
     * @default true
     */
    unstubEnvs: true,

    /**
     * @default true
     */
    unstubGlobals: true,
  },
} as const satisfies UserWorkspaceConfig

/**
 * Default configuration for {@linkcode vitestConfig}.
 *
 * @since 0.0.5
 * @public
 */
export const vitestConfigDefaults = {
  ...vitestProjectDefaults,

  test: {
    ...vitestProjectDefaults.test,

    /**
     * @default { include: ['src/**\/*.?(c|m)[jt]s?(x)'] }
     */
    coverage: {
      /**
       * @default ['src/**\/*.?(c|m)[jt]s?(x)']
       */
      include: ['src/**/*.?(c|m)[jt]s?(x)'],
    },

    /**
     * @default process.env.GITHUB_ACTIONS ? [['default', { summary: false }], ['github-actions', {}]] : [['default', {}]]
     */
    reporters: process.env.GITHUB_ACTIONS
      ? ([
          ['default', { summary: false }],
          ['github-actions', {}],
        ] as const)
      : ([['default', {}]] as const),

    /**
     * @default false
     */
    watch: false,
  },
} as const satisfies ViteUserConfig
